import { render } from "./LinkDetailView.vue?vue&type=template&id=7afc0300&scoped=true"
import script from "./LinkDetailView.vue?vue&type=script&lang=js"
export * from "./LinkDetailView.vue?vue&type=script&lang=js"

import "./LinkDetailView.vue?vue&type=style&index=0&id=7afc0300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afc0300"]])

export default __exports__